import React from 'react';

import { PrimaryButton } from '@/components/Button/PrimaryButton';
import { IEditScreenProps } from 'interfaces/PreviewScreen/previewScreen';
import CloseImg from 'public/assets/close.svg';

const EditScreen = ({
  setIsEditClicked,
  handleDrop,
  progress,
  fileName,
  cancelTokenSource,
  getRootProps,
  getInputProps,
  isDragActive,
  hiddenFileInput,
  isUploading,
  setIsUploading,
}: IEditScreenProps) => {
  const selectEditFile = (acceptedFiles: FileList) => {
    const editFileMock = Array.from(acceptedFiles);
    handleDrop(editFileMock);
  };

  return (
    <div
      {...getRootProps()}
      className=" h-[76vh] relative bg-white p-4 w-full grid grid-rows-6 box-border border-2  rounded-[8px] lg:col-span-2"
    >
      <div
        {...getInputProps()}
        className={`row-span-5 relative rounded-md  ${
          isDragActive
            ? 'bg-yellow opacity-50 border-2 border-black'
            : 'border-2'
        } border-dashed flex items-center justify-center`}
      >
        <h4 className=" text-2xl">Drag and drop a file </h4>
      </div>
      <input
        multiple={true}
        type={'file'}
        ref={hiddenFileInput}
        accept="*"
        style={{ display: 'none' }}
        onChange={(e) => selectEditFile(e.target.files)}
      />
      <div className="items-center grid grid-cols-2">
        <div>
          <PrimaryButton onClick={() => setIsEditClicked(false)}>
            <span>Back </span>
          </PrimaryButton>
        </div>
        <div className="flex justify-end">
          <PrimaryButton onClick={() => hiddenFileInput.current.click()}>
            <span>Select File </span>
          </PrimaryButton>
        </div>
      </div>
      {isUploading && (
        <>
          <section className="absolute top-0 justify-center flex backdrop-blur-md h-full items-center p-8  w-full ">
            <div className="bg-white  flex items-center flex-col border-2  rounded-3xl border-dashed justify-center">
              <div className="text-center text-lg font-semibold">
                <h2>Uploading</h2>
              </div>
              <div className="flex mt-2 justify-center">{fileName}</div>
              <div className="border-2 relative border-gray-400 mt-2 mb-2 border-dashed flex pl-4 pr-1 py-1 rounded-lg h-16 w-[15rem] mx-auto">
                <div className="w-full px-2 my-auto ">
                  <div className="relative w-full h-2 bg-gray-200 rounded-full">
                    <div
                      style={{ width: `${progress}%` }}
                      className="bg-prp absolute inset-0 rounded-full z-10"
                    />
                  </div>
                </div>

                <button
                  onClick={() => {
                    cancelTokenSource?.cancel();
                    setIsUploading(false);
                  }}
                  className="grid w-20 h-full ml-4 bg-yellow rounded-xxs place-items-center"
                >
                  <img src={CloseImg.src} alt="closeImg" />
                </button>
              </div>
            </div>
          </section>
        </>
      )}
    </div>
  );
};

export default EditScreen;
